import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import { ReserveProvider } from "@/contexts/ReserveContext";
import { AuthProvider } from "@/contexts/AuthContext";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import MenuPage from "@/pages/MenuPage";
import WeeklyDrops from "@/pages/WeeklyDrops";
import Vault from "@/pages/Vault";
import Pumabilt from "@/pages/Pumabilt";
import Membership from "@/pages/Membership";
import Events from "@/pages/Events";
import ChimeIn from "@/pages/Contact";
import HouseAlerts from "@/pages/HouseAlerts";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";
import Reserve from "@/pages/Reserve";
import ObsessionList from "@/pages/ObsessionList";
import NotificationSettings from "@/pages/NotificationSettings";
import FAQ from "@/pages/FAQ";
import AtelierLogin from "@/pages/AtelierLogin";
import Atelier from "@/pages/Atelier";
import AtelierChangePassword from "@/pages/AtelierChangePassword";

const TOAST_OPTIONS = {
  style: {
    background: "#0E0E0E",
    border: "1px solid rgba(176,141,70,0.4)",
    color: "#D6C7AE",
    fontFamily: "Outfit, sans-serif",
    letterSpacing: "0.02em",
  },
};

function App() {
  return (
    <AuthProvider>
      <ReserveProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/atelier/login" element={<AtelierLogin />} />
            <Route
              path="/atelier/change-password"
              element={
                <ProtectedRoute>
                  <AtelierChangePassword />
                </ProtectedRoute>
              }
            />
            <Route
              path="/atelier"
              element={
                <ProtectedRoute>
                  <Atelier />
                </ProtectedRoute>
              }
            />
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/menu" element={<MenuPage />} />
              <Route path="/drops" element={<WeeklyDrops />} />
              <Route path="/vault" element={<Vault />} />
              <Route path="/pumabilt" element={<Pumabilt />} />
              <Route path="/membership" element={<Membership />} />
              <Route path="/events" element={<Events />} />
              <Route path="/chime-in" element={<ChimeIn />} />
              <Route path="/contact" element={<Navigate to="/chime-in" replace />} />
              <Route path="/house-alerts" element={<HouseAlerts />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/privacy-policy" element={<Navigate to="/privacy" replace />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/terms-of-service" element={<Navigate to="/terms" replace />} />
              <Route path="/reserve" element={<Reserve />} />
              <Route path="/obsession-list" element={<ObsessionList />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/faqs" element={<Navigate to="/faq" replace />} />
              <Route path="/admin/notification-settings" element={<NotificationSettings />} />
              <Route path="*" element={<Home />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-right" toastOptions={TOAST_OPTIONS} />
      </ReserveProvider>
    </AuthProvider>
  );
}

export default App;
